import { t } from '../../../locales';
import NewRuleButton from './pages/shipping-fees-and-locations/components/new-rule-btn.vue';
import NewGroupButton from './pages/location-groups/components/new-group-btn.vue';
import UsersHeaderActions from './pages/users/components/header-actions.vue';
import RolesHeaderActions from './pages/roles/components/header-actions.vue';
import { useAuthStore } from '../../store/shared/auth-store';
import { featureFlag } from '../../entities/feature-flag';

const settingsModuleRoutes = {
	path: 'settings',
	component: () => import('./module-layout.vue'),
	meta: {},
	children: [
		{
			path: 'orders-returns',
			component: () => import('./pages/orders-returns/index.vue'),
			meta: {
				title: t('settings.shipping-settings'),
			},
		},
		{
			path: 'shipping-fees-locations',
			name: 'settings-shipping-fees-locations',
			component: () => import('./pages/shipping-fees-and-locations/index.vue'),
			meta: {
				title: t('settings.shipping-fees-locations'),
				headerExtraComponent: NewRuleButton,
			},
		},
		{
			path: 'location-groups',
			name: 'settings-location-groups',
			component: () => import('./pages/location-groups/index.vue'),
			meta: {
				title: t('settings.location-groups'),
				headerExtraComponent: NewGroupButton,
			},
		},
		{
			path: 'invoices',
			component: () => import('./pages/invoices-settings/index.vue'),
			meta: {
				title: t('settings.invoices-settings'),
			},
		},
		{
			path: 'users',
			component: () => import('./pages/users/index.vue'),
			meta: {
				title: t('settings.manage-users'),
				headerExtraComponent: UsersHeaderActions,
				can: () => {
					const authStore = useAuthStore();
					return authStore.isOwner;
				},
			},
		},
		{
			path: 'roles',
			name: 'settings-roles',
			component: () => import('./pages/roles/index.vue'),
			meta: {
				title: t('settings.roles-management'),
				headerExtraComponent: RolesHeaderActions,
				can: () => {
					const authStore = useAuthStore();
					return authStore.isOwner;
				},
			},
		},
		{
			path: 'my-fatoorah',
			component: () => import('./pages/my-fatoorah/index.vue'),
			meta: {
				title: t('settings.my-fatoorah'),
			},
		},
	],
};

export { settingsModuleRoutes };
